import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {NomPiece} from 'app/models/nomPiece.model';
import {PieceEquipement} from 'app/models/pieceEquipement.model';
import {EquipementService} from 'app/services/equipement.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {UserService} from '../../../../core/user/user.service';
import {ModalConfirm} from '../../../../shared/modal-confirm/modal-confirm.component';
import {ModalEquipementV2Component} from './modal-equipement-v2.component';

@Component({
    selector: 'app-equipement-v2',
    templateUrl: './equipement-v2.component.html',
    styleUrls: ['./equipement-v2.component.scss']
})
export class EquipementV2Component implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention;
    @Input() piecesEquipements: PieceEquipement[] = [];
    @Input() nomsPieces: NomPiece[] = [];

    @Output() refreshPieces: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(
        private userService: UserService,
        private dossierService: DossierInterventionService,
        private dialog: MatDialog,
    ) {
    }

    get isAdmin(): boolean {
        return this.userService.getCurrentUser().role_id === 1;
    }

    ngOnInit(): void {
    }

    getNomPiece(pieceEquipement: PieceEquipement): string {
        if (pieceEquipement.piece != null && pieceEquipement.piece.nom_piece_id != null) {
            return this.nomsPieces.find(nomPiece => nomPiece.id == pieceEquipement.piece.nom_piece_id)?.nom ?? '';
        } else {
            return '';
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    store(): void {
        const dialogRef = this.openPieceModal();
    }

    update(pieceEquipement: PieceEquipement): void {
        const dialogRef = this.openPieceModal();

        dialogRef.componentInstance.pieceEquipement = pieceEquipement;
    }

    destroy(pieceEquipement: PieceEquipement): void {
        const dialogRef = this.dialog.open(ModalConfirm, {
            width: '50%',
        });
        dialogRef.componentInstance.confirmationMessage = 'Voulez-vous supprimer cet équipement de ce dossier?';
        dialogRef.afterClosed().subscribe((result) => {
            if(result === true) {
                this.dossierService.destroyPieceEquipementForDossierIntervention(this.currentDossierIntervention.id, pieceEquipement).subscribe(()=>{
                    this.refreshPieces.emit(true);
                });
            }
        });
    }

    openPieceModal(): MatDialogRef<ModalEquipementV2Component> {
        const dialogRef = this.dialog.open(ModalEquipementV2Component, {
            width: '75%',
        });

        dialogRef.componentInstance.idDossierIntervention = this.currentDossierIntervention.id;

        dialogRef.afterClosed().subscribe((result) => {
            this.refreshPieces.emit(true);
        });

        return dialogRef;
    }
}
